// src/components/InactivityTimer.js
import React, { useState, useEffect, useRef } from "react"

import styles from "./inactivityTimer.module.scss"

// Close icon
import Close from "../../assets/images/icons/close.svg"

const InactivityTimer = ({ timeout = 300000, videoUrl = "https://res.cloudinary.com/hwti4wnct/video/upload/v1770657313/STATIC/garage-ipads/iPad_Screensaver_2026_mozwf1.mp4" }) => {
	const [isInactive, setIsInactive] = useState(false)
	const timeoutRef = useRef(null)
	const videoContainerRef = useRef(null)
	const videoRef = useRef(null)

	// Reset timer when user is active
	const resetTimer = () => {
		if (timeoutRef.current) {
			clearTimeout(timeoutRef.current)
		}

		// If the video is showing, hide it
		if (isInactive) {
			setIsInactive(false)
		}

		// Set a new timer
		timeoutRef.current = setTimeout(() => {
			setIsInactive(true)
		}, timeout)
	}

	// Handle video display based on inactivity state
	useEffect(() => {
		// console.log("Inactivity state:", isInactive)

		if (isInactive) {
			// Show video container
			if (videoContainerRef.current) {
				videoContainerRef.current.style.display = "block"
			}

			// Play video
			if (videoRef.current) {
				videoRef.current.play().catch((err) => {
					console.error("Error playing video:", err)
				})
			}
		} else {
			// Hide video container
			if (videoContainerRef.current) {
				videoContainerRef.current.style.display = "none"
			}

			// Pause video
			if (videoRef.current) {
				videoRef.current.pause()
			}
		}
	}, [isInactive])

	// Set up activity listeners
	useEffect(() => {
		// List of events to track
		const events = ["mousedown", "mousemove", "keydown", "touchstart", "touchmove", "scroll", "click", "keypress"]

		// Add event listeners
		events.forEach((event) => {
			window.addEventListener(event, resetTimer)
		})

		// Start the initial timer
		resetTimer()

		// Cleanup when component unmounts
		return () => {
			if (timeoutRef.current) {
				clearTimeout(timeoutRef.current)
			}

			// Remove event listeners
			events.forEach((event) => {
				window.removeEventListener(event, resetTimer)
			})
		}
	}, [timeout])

	return (
		<div
			ref={videoContainerRef}
			className={styles.videoContainer}
			onClick={resetTimer}>
			<img
				className={styles.closeTouchpoint}
				src={Close}
				alt="Close"
			/>
			<video
				ref={videoRef}
				src={videoUrl}
				className={styles.video}
				muted
				loop
				playsInline
			/>
		</div>
	)
}

export default InactivityTimer
